import { ThemeMode } from '@fleet-beat/core';

export interface ConfirmDialogOptions<T> {
  currentThemeMode?: ThemeMode;
  title: string;
  text: string;
  additionText?: string;
  buttons: ConfirmDialogActionOptions<T>[];
  closeAction?: T;
  hasCloseButton?: boolean;
}

export interface ConfirmDialogActionOptions<T> {
  caption: string;
  action?: T;
  color?: 'empty' | 'success' | 'error';
}
